/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Spreadsheet_No_DataInputs */



/**
* | output |
* | --- |
* | "No data found." |
*
* @param {Spaces_Spreadsheet_No_DataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_spreadsheet_no_data = /** @type {((inputs?: Spaces_Spreadsheet_No_DataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Spreadsheet_No_DataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Daten gefunden.")
	return /** @type {LocalizedString} */ ("No data found.")
});